// GENERATED by apps/web/scripts/generate-sector-data.mjs — do not hand-edit.
// See that script's header comment for what this data is and how to refresh it.

export interface SectorInfo {
  slug: string;
  name: string;
  count: number;
}

export const SECTORS: SectorInfo[] = [
  {
    "slug": "food-beverage-and-tobacco",
    "name": "Food, Beverage & Tobacco",
    "count": 48
  },
  {
    "slug": "diversified-financials",
    "name": "Diversified Financials",
    "count": 36
  },
  {
    "slug": "consumer-services",
    "name": "Consumer Services",
    "count": 35
  },
  {
    "slug": "capital-goods",
    "name": "Capital Goods",
    "count": 29
  },
  {
    "slug": "materials",
    "name": "Materials",
    "count": 24
  },
  {
    "slug": "real-estate-management-and-development",
    "name": "Real Estate Management & Development",
    "count": 20
  },
  {
    "slug": "banks",
    "name": "Banks",
    "count": 17
  },
  {
    "slug": "insurance",
    "name": "Insurance",
    "count": 14
  },
  {
    "slug": "retailing",
    "name": "Retailing",
    "count": 14
  },
  {
    "slug": "health-care-equipment-and-services",
    "name": "Health Care Equipment & Services",
    "count": 9
  },
  {
    "slug": "utilities",
    "name": "Utilities",
    "count": 9
  },
  {
    "slug": "consumer-durables-and-apparel",
    "name": "Consumer Durables & Apparel",
    "count": 8
  },
  {
    "slug": "commercial-and-professional-services",
    "name": "Commercial & Professional Services",
    "count": 6
  },
  {
    "slug": "energy",
    "name": "Energy",
    "count": 3
  }
];

// Site symbol (e.g. "COMB.N0000") -> sector slug (e.g. "banks")
export const SYMBOL_SECTOR: Record<string, string> = {
  "AAF.N0000": "diversified-financials",
  "AAIC.N0000": "insurance",
  "ABAN.N0000": "consumer-durables-and-apparel",
  "ABL.N0000": "banks",
  "ACL.N0000": "capital-goods",
  "ACME.N0000": "materials",
  "AEL.N0000": "capital-goods",
  "AFS.N0000": "capital-goods",
  "AFSL.N0000": "diversified-financials",
  "AGAL.N0000": "food-beverage-and-tobacco",
  "AGPL.N0000": "food-beverage-and-tobacco",
  "AGST.N0000": "materials",
  "AGST.X0000": "materials",
  "AHPL.N0000": "consumer-services",
  "AHUN.N0000": "consumer-services",
  "AINS.N0000": "insurance",
  "ALLI.N0000": "diversified-financials",
  "ALUM.N0000": "materials",
  "AMCL.N0000": "diversified-financials",
  "AMSL.N0000": "health-care-equipment-and-services",
  "APLA.N0000": "materials",
  "ASCO.N0000": "real-estate-management-and-development",
  "ASHO.N0000": "capital-goods",
  "ASIR.N0000": "health-care-equipment-and-services",
  "ASIY.N0000": "diversified-financials",
  "ASPH.N0000": "materials",
  "ATL.N0000": "insurance",
  "ATLL.N0000": "insurance",
  "AUTO.N0000": "retailing",
  "BALA.N0000": "food-beverage-and-tobacco",
  "BERU.N0000": "consumer-services",
  "BFL.N0000": "food-beverage-and-tobacco",
  "BFN.N0000": "diversified-financials",
  "BIL.N0000": "food-beverage-and-tobacco",
  "BOGA.N0000": "materials",
  "BOPL.N0000": "food-beverage-and-tobacco",
  "BREW.N0000": "food-beverage-and-tobacco",
  "BRR.N0000": "consumer-services",
  "BRWN.N0000": "capital-goods",
  "BUKI.N0000": "food-beverage-and-tobacco",
  "CABO.N0000": "real-estate-management-and-development",
  "CALF.N0000": "diversified-financials",
  "CALH.N0000": "diversified-financials",
  "CARE.N0000": "commercial-and-professional-services",
  "CARS.N0000": "food-beverage-and-tobacco",
  "CBNK.N0000": "banks",
  "CCS.N0000": "food-beverage-and-tobacco",
  "CDB.N0000": "diversified-financials",
  "CDB.X0000": "diversified-financials",
  "CERA.N0000": "capital-goods",
  "CFI.N0000": "diversified-financials",
  "CFIN.N0000": "diversified-financials",
  "CFLB.N0000": "capital-goods",
  "CFVF.N0000": "diversified-financials",
  "CHL.N0000": "health-care-equipment-and-services",
  "CHL.X0000": "health-care-equipment-and-services",
  "CHMX.N0000": "materials",
  "CHOT.N0000": "consumer-services",
  "CIC.N0000": "materials",
  "CIC.X0000": "materials",
  "CIND.N0000": "capital-goods",
  "CINS.N0000": "insurance",
  "CINS.X0000": "insurance",
  "CINV.N0000": "diversified-financials",
  "CIT.N0000": "diversified-financials",
  "CITH.N0000": "consumer-services",
  "CITW.N0000": "consumer-services",
  "CLND.N0000": "real-estate-management-and-development",
  "COCO.N0000": "food-beverage-and-tobacco",
  "COCO.X0000": "food-beverage-and-tobacco",
  "COCR.N0000": "diversified-financials",
  "COLO.N0000": "retailing",
  "COMB.N0000": "banks",
  "COMB.X0000": "banks",
  "COMD.N0000": "real-estate-management-and-development",
  "CONN.N0000": "consumer-services",
  "COOP.N0000": "insurance",
  "CPRT.N0000": "real-estate-management-and-development",
  "CRL.N0000": "diversified-financials",
  "CSD.N0000": "real-estate-management-and-development",
  "CSLK.N0000": "capital-goods",
  "CTBL.N0000": "retailing",
  "CTC.N0000": "food-beverage-and-tobacco",
  "CTEA.N0000": "food-beverage-and-tobacco",
  "CTLD.N0000": "real-estate-management-and-development",
  "CWM.N0000": "retailing",
  "DFCC.N0000": "banks",
  "DIMO.N0000": "retailing",
  "DIPD.N0000": "materials",
  "DIST.N0000": "food-beverage-and-tobacco",
  "DOCK.N0000": "capital-goods",
  "DPL.N0000": "consumer-durables-and-apparel",
  "EAST.N0000": "real-estate-management-and-development",
  "EBCR.N0000": "capital-goods",
  "ECL.N0000": "health-care-equipment-and-services",
  "EDEN.N0000": "consumer-services",
  "ELPL.N0000": "food-beverage-and-tobacco",
  "EMER.N0000": "retailing",
  "EML.N0000": "commercial-and-professional-services",
  "ETWO.N0000": "real-estate-management-and-development",
  "EXT.N0000": "commercial-and-professional-services",
  "GEST.N0000": "commercial-and-professional-services",
  "GHLL.N0000": "consumer-services",
  "GLAS.N0000": "materials",
  "GRAN.N0000": "food-beverage-and-tobacco",
  "GREG.N0000": "consumer-durables-and-apparel",
  "GUAR.N0000": "diversified-financials",
  "HAPU.N0000": "food-beverage-and-tobacco",
  "HARI.N0000": "food-beverage-and-tobacco",
  "HASU.N0000": "insurance",
  "HAYC.N0000": "materials",
  "HAYL.N0000": "capital-goods",
  "HDFC.N0000": "banks",
  "HEXP.N0000": "consumer-durables-and-apparel",
  "HHL.N0000": "capital-goods",
  "HNB.N0000": "banks",
  "HNB.X0000": "banks",
  "HOPL.N0000": "food-beverage-and-tobacco",
  "HPFL.N0000": "utilities",
  "HPL.N0000": "food-beverage-and-tobacco",
  "HPWR.N0000": "utilities",
  "HSIG.N0000": "consumer-services",
  "HUNA.N0000": "consumer-services",
  "HUNT.N0000": "retailing",
  "HVA.N0000": "food-beverage-and-tobacco",
  "INME.N0000": "insurance",
  "JAT.N0000": "materials",
  "JETS.N0000": "consumer-services",
  "JFP.N0000": "materials",
  "JINS.N0000": "insurance",
  "JKH.N0000": "capital-goods",
  "JKL.N0000": "retailing",
  "KAHA.N0000": "food-beverage-and-tobacco",
  "KCAB.N0000": "capital-goods",
  "KFP.N0000": "food-beverage-and-tobacco",
  "KGAL.N0000": "food-beverage-and-tobacco",
  "KHC.N0000": "consumer-services",
  "KHL.N0000": "consumer-services",
  "KOTA.N0000": "food-beverage-and-tobacco",
  "KPHL.N0000": "retailing",
  "KVAL.N0000": "food-beverage-and-tobacco",
  "KZOO.N0000": "real-estate-management-and-development",
  "LALU.N0000": "materials",
  "LAMB.N0000": "food-beverage-and-tobacco",
  "LCBF.N0000": "diversified-financials",
  "LCEY.N0000": "capital-goods",
  "LDEV.N0000": "food-beverage-and-tobacco",
  "LFIN.N0000": "diversified-financials",
  "LGIL.N0000": "insurance",
  "LGL.N0000": "energy",
  "LGL.X0000": "energy",
  "LHCL.N0000": "health-care-equipment-and-services",
  "LHL.N0000": "consumer-services",
  "LIOC.N0000": "energy",
  "LION.N0000": "food-beverage-and-tobacco",
  "LITE.N0000": "capital-goods",
  "LLUB.N0000": "materials",
  "LMF.N0000": "food-beverage-and-tobacco",
  "LOFC.N0000": "diversified-financials",
  "LOLC.N0000": "diversified-financials",
  "LPL.N0000": "utilities",
  "LPL.X0000": "utilities",
  "LPRT.N0000": "commercial-and-professional-services",
  "LUMX.N0000": "capital-goods",
  "LVEF.N0000": "utilities",
  "LVEN.N0000": "diversified-financials",
  "LWL.N0000": "capital-goods",
  "MADU.N0000": "food-beverage-and-tobacco",
  "MAL.N0000": "food-beverage-and-tobacco",
  "MAL.X0000": "food-beverage-and-tobacco",
  "MARA.N0000": "consumer-services",
  "MASK.N0000": "food-beverage-and-tobacco",
  "MBSL.N0000": "diversified-financials",
  "MBSL.P0000": "diversified-financials",
  "MCPL.N0000": "food-beverage-and-tobacco",
  "MDL.N0000": "real-estate-management-and-development",
  "MEL.N0000": "capital-goods",
  "MELS.N0000": "food-beverage-and-tobacco",
  "MERC.N0000": "diversified-financials",
  "MFPE.N0000": "food-beverage-and-tobacco",
  "MGT.N0000": "consumer-durables-and-apparel",
  "MHDL.N0000": "real-estate-management-and-development",
  "MRH.N0000": "consumer-services",
  "MULL.N0000": "health-care-equipment-and-services",
  "NAMU.N0000": "food-beverage-and-tobacco",
  "NDB.N0000": "banks",
  "NEH.N0000": "consumer-services",
  "NHL.N0000": "health-care-equipment-and-services",
  "NTB.N0000": "banks",
  "NTB.X0000": "banks",
  "ODEL.N0000": "retailing",
  "OFEQ.N0000": "capital-goods",
  "ONAL.N0000": "real-estate-management-and-development",
  "OSEA.N0000": "real-estate-management-and-development",
  "PABC.N0000": "banks",
  "PACK.N0000": "materials",
  "PALM.N0000": "consumer-services",
  "PAP.N0000": "utilities",
  "PARA.N0000": "commercial-and-professional-services",
  "PARQ.N0000": "materials",
  "PEG.N0000": "consumer-services",
  "PHAR.N0000": "real-estate-management-and-development",
  "PINS.N0000": "insurance",
  "PLC.N0000": "diversified-financials",
  "PLR.N0000": "real-estate-management-and-development",
  "PMB.N0000": "diversified-financials",
  "RAL.N0000": "food-beverage-and-tobacco",
  "RCH.N0000": "consumer-services",
  "RCL.N0000": "capital-goods",
  "REEF.N0000": "consumer-services",
  "RENU.N0000": "consumer-services",
  "REXP.N0000": "materials",
  "RFL.N0000": "consumer-services",
  "RGEM.N0000": "consumer-durables-and-apparel",
  "RHL.N0000": "capital-goods",
  "RHL.X0000": "capital-goods",
  "RHTL.N0000": "consumer-services",
  "RICH.N0000": "capital-goods",
  "RIL.N0000": "retailing",
  "RPBH.N0000": "consumer-services",
  "RWSL.N0000": "food-beverage-and-tobacco",
  "SAMP.N0000": "banks",
  "SCAP.N0000": "insurance",
  "SDB.N0000": "banks",
  "SEMB.N0000": "diversified-financials",
  "SEMB.X0000": "diversified-financials",
  "SERV.N0000": "consumer-services",
  "SEYB.N0000": "banks",
  "SEYB.X0000": "banks",
  "SFCL.N0000": "diversified-financials",
  "SFIN.N0000": "diversified-financials",
  "SHAW.N0000": "real-estate-management-and-development",
  "SHL.N0000": "capital-goods",
  "SHOT.N0000": "consumer-services",
  "SHOT.X0000": "consumer-services",
  "SIGV.N0000": "consumer-services",
  "SIL.N0000": "materials",
  "SING.N0000": "real-estate-management-and-development",
  "SINH.N0000": "health-care-equipment-and-services",
  "SINS.N0000": "retailing",
  "SIRA.N0000": "capital-goods",
  "SLND.N0000": "real-estate-management-and-development",
  "SMOT.N0000": "retailing",
  "SOY.N0000": "food-beverage-and-tobacco",
  "SPEN.N0000": "capital-goods",
  "STAF.N0000": "consumer-services",
  "SUN.N0000": "food-beverage-and-tobacco",
  "TAFL.N0000": "food-beverage-and-tobacco",
  "TAJ.N0000": "consumer-services",
  "TANG.N0000": "consumer-services",
  "TAP.N0000": "consumer-durables-and-apparel",
  "TILE.N0000": "capital-goods",
  "TJL.N0000": "consumer-durables-and-apparel",
  "TKYO.N0000": "materials",
  "TKYO.X0000": "materials",
  "TPL.N0000": "food-beverage-and-tobacco",
  "TRAN.N0000": "consumer-services",
  "TSML.N0000": "food-beverage-and-tobacco",
  "UAL.N0000": "insurance",
  "UBC.N0000": "banks",
  "UBF.N0000": "diversified-financials",
  "UCAR.N0000": "materials",
  "UDPL.N0000": "food-beverage-and-tobacco",
  "UML.N0000": "retailing",
  "VFIN.N0000": "diversified-financials",
  "VLL.N0000": "utilities",
  "VLL.X0000": "utilities",
  "VONE.N0000": "utilities",
  "WAPO.N0000": "diversified-financials",
  "WATA.N0000": "food-beverage-and-tobacco",
  "WLTH.N0000": "diversified-financials",
  "YORK.N0000": "real-estate-management-and-development"
};
